import { motion } from 'framer-motion';
import Image from 'next/image';

import { ISanitizedCompany } from 'types/company';

import { useFadeInTransition } from 'hooks/browser/transitions';

import { FooterMenu } from 'components/shared/layout/FooterMenu';

import StoryDemo from '../../../../../public/authentication/story_demo.png';

import { TSection, useSections } from './AuthProtection.hooks';
import { SignIn } from './SignIn';
import { SignUp } from './SignUp';

interface IProps {
  company?: ISanitizedCompany;
  initialSection?: TSection;
}

export const AuthProtection = ({
  company,
  initialSection = 'sign-in',
}: IProps) => {
  const { currentSection, handleSwitchSection } = useSections({
    initialSection,
  });
  const { container, item } = useFadeInTransition();

  return (
    <section className="flex h-full items-stretch bg-white dark:bg-codGrey">
      <div className="fixed hidden h-full w-[50%] bg-culturedPearlGrey dark:bg-white dark:bg-opacity-10 md:block">
        <div className="mx-auto flex h-full flex-col items-center justify-center p-4">
          <div className="max-w-[400px]">
            <Image
              src={StoryDemo}
              alt="Bite illustration"
              style={{ objectFit: 'contain' }}
            />
          </div>

          <div className="max-w-[480px]">
            <h2 className="mb-4 mt-10 text-center text-4xl font-bold">
              Vereinfache deine Kommunikation
            </h2>

            <p className="text-center text-lg font-thin">
              Teile deine Inhalte mit deiner Zielgruppe - direkt, verständlich
              und immer verfügbar.
            </p>
          </div>
        </div>
      </div>

      <div className="flex min-h-screen flex-grow flex-col md:pl-[50%]">
        <div className="flex h-full w-full flex-col items-center justify-center">
          <div className="w-full max-w-[400px] px-4 pb-6 pt-12">
            <motion.div variants={container} initial="hidden" animate="show">
              {currentSection === 'sign-up' ? (
                <motion.section key={0} variants={item}>
                  <SignUp
                    company={company}
                    switchSection={handleSwitchSection}
                  />
                </motion.section>
              ) : (
                <motion.section key={1} variants={item}>
                  <SignIn
                    company={company}
                    switchSection={handleSwitchSection}
                  />
                </motion.section>
              )}
            </motion.div>
          </div>
        </div>

        <div className="flex-shrink-0 self-center justify-self-end py-7 md:self-end md:px-16">
          <FooterMenu />
        </div>
      </div>
    </section>
  );
};
